<script setup lang="ts">
    import { ref, defineExpose } from 'vue';

    const title = ref('');
    const message = ref('');
    const isModalOpen = ref(false);
    let promise: Promise<boolean>;
    let resolvePromise: any;
    let rejectPromise: any;

    async function open(_title: string, _message: string) {
        title.value = _title;
        message.value = _message;
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        isModalOpen.value = true;
        return await promise;
    }

    function onClose() {
        resolvePromise(false);
    }

    function onConfirm() {
        resolvePromise(true);
        isModalOpen.value = false;
    }

    function onReject() {
        resolvePromise(false);
        isModalOpen.value = false;
    }

    defineExpose({ open });
</script>

<template>
    <custom-modal v-model:show="isModalOpen" @closed="onClose">
        <template #header>
            <h4 class="font-semibold">{{ title }}</h4>
        </template>
        <p>{{ message }}</p>
        <template #footer>
            <button id="btn-confirmation-confirm" class="btn-ultra white2" style="justify-content: center;" @click="onConfirm">Oui</button>
            <button id="btn-confirmation-reject" class="btn-ultra white2" style="justify-content: center;" @click="onReject">Non</button>
        </template>
    </custom-modal>
</template>
